import clsx from 'clsx';
import React, { FC } from 'react';

import styles from './PatientPanelHeader.module.scss';

export interface Props {
  title: string;
  children?: React.ReactNode;
  className?: string;
}

export const PatientPanelHeader: FC<React.PropsWithChildren<Props>> = (
  props,
) => {
  return (
    <div className={clsx(styles.container, props.className)}>
      <div className={styles.title}>{props.title}</div>
      {props.children}
    </div>
  );
};
